import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './Legal.css';

// The App Clip's page. On an iPhone, Safari shows the clip card from the
// apple-itunes-app meta tag in index.html and opens the clip; everywhere
// else this page explains what they would have seen and links to the app.
export default function Clip() {
  const [params] = useSearchParams();
  const pet = (params.get('pet') || 'a petling').replace(/_/g, ' ');
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-card card">
          <h1>Meet {pet}</h1>
          <p className="legal-updated">In 3D, before you install anything.</p>
          <section>
            <p>
              On an iPhone, this link opens a small piece of Petlings right away: one petling on a stage, a tap to say hi,
              a drag to turn it. If you are reading this instead, open the link on an iPhone, or get the full app.
            </p>
            <p>
              Petlings is a pet that goes with you into Minecraft and remembers what you did there.{' '}
              <Link to="/about">About Petlings</Link> &middot; <Link to="/support">Support</Link>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
